
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.707 6.293l-4-4c-.014-.015-.035-.02-.05-.034a.986.986 0 00-.22-.148c-.041-.021-.079-.04-.122-.056A.99.99 0 0025 2H7a.904.904 0 00-.44.112.987.987 0 00-.216.146c-.015.014-.036.02-.051.035l-4 4a1 1 0 00-.05 1.36L10.95 17.74l-5.706 6.607a1 1 0 00.05 1.36l4 4c.188.188.442.293.707.293l.037-.001a.996.996 0 00.72-.346L16 23.581l5.242 6.072A.996.996 0 0022 30c.265 0 .519-.105.707-.293l4-4a1 1 0 00.05-1.36l-5.709-6.61 8.709-10.084a1 1 0 00-.05-1.36zM22.814 4l-2.591 3h-8.446L9.186 4h13.628zm-15.868.468l7.733 8.952-2.409 2.79-7.906-9.16 2.582-2.582zM13.503 9h4.994L16 11.89 13.503 9zm6.226 10.27l4.907 5.68-2.582 2.582-4.732-5.48.408-.473 1.999-2.31zm-3.302.758l-1.183 1.368c-.003.002-.003.006-.006.009l-5.292 6.127-2.582-2.582 5.663-6.556.049-.057 11.978-13.87 2.582 2.583-11.21 12.978z"}})])
          )
        }
      }
    